/**
 * Initialize modal functions
 */
export function initModal() {
    let modal = document.querySelector('.modal');

    if (modal) {
        let closeBtn = modal.querySelector('.js-close');

        modal.addEventListener('click', function(evt) {
            // Match modal, not children
            if (evt.target === this) {
                hideModal(modal);
            }
        });

        closeBtn.addEventListener('click', function() {
            hideModal(modal);
        });
    }
}

function showModal(modal) {
    modal.classList.add( 'visible' );
    document.querySelector('body').style.overflow = 'hidden';
}

function hideModal(modal) {
    modal.classList.remove('visible');
    document.querySelector('body').style.overflow = 'initial';
}

/**
 *
 */
export function enquireFormModal() {
    const modal = document.querySelector('.enquire-form__modal');

    function populateFormFields() {
        let serviceField = modal.querySelector('.js-latest-service-field input');
        let locationField = modal.querySelector('.js-latest-location-field input');

        if (serviceField) {
            serviceField.value = localStorage.getItem('latest-service');
        }

        if (locationField) {
            locationField.value = localStorage.getItem('latest-location');
        }
    }

    if (modal) {
        const confirmationClass = 'confirmation-loaded';
        const cards = document.querySelectorAll('.search-service-results__container, .search-service-results__no-service-container');
        let buttons = [];

        populateFormFields();

        if (cards) {
            for (let i = 0; i < cards.length; i++) {
                const button = cards[i].querySelector('a[href$="/enquire/"]');

                if (button) {
                    buttons.push(button);
                }
            }
        }

        if (buttons) {
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].addEventListener('click', function(e) {
                    e.preventDefault();
                    showModal( modal );
                });
            }
        }

        // Bind to gravity forms event.
        // Kept jQuery since it doesn't trigger vanilla js listener.
        jQuery(document).bind('gform_confirmation_loaded', function(event, formId) {
            modal.classList.add(confirmationClass);
        });
    }
}

/*
 * Phone button modal
 */
export function phoneModal() {
    const modal = document.querySelector('.phone__modal');

    if ( modal ) {
        const buttons = document.querySelectorAll('.button--opens-phone-modal');

        for ( let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener('click', function(e) {
                e.preventDefault();
                showModal( modal );
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/modals.js